import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shop",
  "use": "icon-shop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-shop\"><defs><style type=\"text/css\"></style></defs><path d=\"M765.5 126.2h-510L109.8 376.9h801.4L765.5 126.2zM110.4 427h-0.6c-0.4 10.9 0 35.9 0 50.1 0 26.7 9.6 55.9 25.1 75.2l0.8 275.8c0 55.4 46.3 100.3 103.4 100.3H782c57.1 0 105-44.9 105-100.3V552.3c17.6-20.7 25.1-41.9 25.1-75.2V427H110.4z m726.4 300.8H185.1l-0.1-150.4h49.2c26.9 0 69.6-24 87.7-60.8 20.3 35.7 58.2 60.8 94.3 60.8 38.2 0 80.2-22.7 94.3-55.5 14 32 55.2 55.5 92.6 55.5 37.1 0 75.5-27.3 95-64.5 22.7 37.6 55.1 64.5 88.6 64.5 7.3 0 43.7 1.2 50.1 0v150.4z\" p-id=\"1178\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shop.svg
// module id = hert
// module chunks = 4